var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.108 15.8239V6.44601H2.21596V15.8239H14.108ZM14.108 2.17606C14.5602 2.17606 14.9593 2.34898 15.3052 2.69484C15.651 3.04069 15.8239 3.43975 15.8239 3.89202V15.8239C15.8239 16.2762 15.651 16.6753 15.3052 17.0211C14.9593 17.3404 14.5602 17.5 14.108 17.5H2.21596C1.73709 17.5 1.32473 17.3404 0.978873 17.0211C0.659624 16.6753 0.5 16.2762 0.5 15.8239V3.89202C0.5 3.43975 0.659624 3.04069 0.978873 2.69484C1.32473 2.34898 1.73709 2.17606 2.21596 2.17606H3.05399V0.5H4.76995V2.17606H11.554V0.5H13.27V2.17606H14.108ZM12.4319 8.16197V9.83803H10.716V8.16197H12.4319ZM9 8.16197V9.83803H7.32394V8.16197H9ZM5.60798 8.16197V9.83803H3.89202V8.16197H5.60798Z",
    fill: "#193051"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.e881e22f63c38ed29e56f331a45d591b.svg";
export { ForwardRef as ReactComponent };